import React from 'react';
import '@wix/design-system/styles.global.css';
import CampaignListPage from './pages/CampaignListPage';
import { AuthProvider, FirebaseAppProvider, FirestoreProvider, useFirebaseApp } from 'reactfire';
import { firebaseConfig } from './utils/firebaseConfig';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { USE_EMULATORS } from './utils/config';
import { InstaceContextProvider, useInstanceContext } from './context/InstanceContext';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { ToastContextProvider } from './context/ToastContext';
import { NavigationContextProvider, useNavigation } from './context/NavigationContext';
import ResponsesPage from './pages/ResponsesPage';


function PageApp() {
  const { page } = useNavigation();
  const { instanceId } = useInstanceContext();

  const renderPage = () => {
    if (page === 'responses') {
      return <ResponsesPage />
    }
    return <CampaignListPage />
  }

  return <>
    <span data-instance-id={instanceId} />
    {renderPage()}
  </>

}

function FirebaseApp() {
  const firebaseApp = useFirebaseApp();
  const firestoreInstance = getFirestore(firebaseApp);
  if (USE_EMULATORS) {
    connectFirestoreEmulator(firestoreInstance, "localhost", 8080);
  }
  const authInstance = getAuth(firebaseApp);
  if (USE_EMULATORS) {
    connectAuthEmulator(authInstance, "http://localhost:9099");
  }

  return <FirestoreProvider sdk={firestoreInstance}>
    <AuthProvider sdk={authInstance}>
      <ToastContextProvider>
        <InstaceContextProvider>
          <NavigationContextProvider>
            <PageApp />
          </NavigationContextProvider>
        </InstaceContextProvider>
      </ToastContextProvider>
    </AuthProvider>
  </FirestoreProvider>
}

function App() {
  return <FirebaseAppProvider firebaseConfig={firebaseConfig}>

    <FirebaseApp />

  </FirebaseAppProvider>
}
export default App;
